import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "../../components/landing/Logo";

export const LegalLayout = ({ title, updated, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} | TopEstofos`;
    return () => {
      document.title = "TopEstofos | Higienização de Estofos em Lisboa";
    };
  }, [title]);

  return (
    <div className="min-h-screen bg-mist">
      <header className="glass-nav sticky top-0 z-50 border-b border-slate-100">
        <div className="mx-auto flex h-[72px] max-w-4xl items-center justify-between px-4 sm:px-6">
          <Link to="/" data-testid="legal-logo" aria-label="TopEstofos — voltar à página inicial">
            <Logo />
          </Link>
          <Link
            to="/"
            data-testid="legal-back"
            className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-navy transition-all duration-300 hover:border-brand/40 hover:text-brand"
          >
            <ArrowLeft className="h-4 w-4" />
            Voltar
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:py-16">
        <div className="rounded-3xl border border-slate-100 bg-white p-6 shadow-[0_8px_40px_rgba(11,25,44,0.06)] sm:p-10">
          <span className="font-mono text-xs font-semibold uppercase tracking-[0.22em] text-aqua">
            TopEstofos
          </span>
          <h1 className="mt-3 text-3xl font-extrabold tracking-tight text-navy sm:text-4xl">
            {title}
          </h1>
          {updated && <p className="mt-2 text-xs text-slate-400">Última atualização: {updated}</p>}
          <div className="legal-content mt-8">{children}</div>
        </div>
      </main>

      <footer className="border-t border-slate-100 bg-white">
        <div className="mx-auto flex max-w-4xl flex-col items-center justify-between gap-4 px-4 py-8 text-xs text-slate-500 sm:flex-row sm:px-6">
          <p>© 2026 TopEstofos. Todos os direitos reservados.</p>
          <nav className="flex flex-wrap justify-center gap-5" aria-label="Páginas legais">
            <Link to="/politica-de-privacidade" data-testid="legal-footer-privacy" className="transition-colors hover:text-brand">
              Política de Privacidade
            </Link>
            <Link to="/politica-de-cookies" data-testid="legal-footer-cookies" className="transition-colors hover:text-brand">
              Política de Cookies
            </Link>
            <Link to="/termos-e-condicoes" data-testid="legal-footer-terms" className="transition-colors hover:text-brand">
              Termos e Condições
            </Link>
          </nav>
        </div>
      </footer>
    </div>
  );
};
